import React from 'react';
import { LanguageContext, LanguageContextType } from './LanguageContext';

interface LanguageContextProviderProps {
    children: React.ReactNode;
}

export const LanguageContextProvider = ({ children }: LanguageContextProviderProps): React.ReactElement => {
    const [siteLang, setSiteLang] = React.useState<'nb' | 'en'>('nb');

    const languageContext: LanguageContextType = React.useMemo(() => ({
        siteLang,
        setSiteLang,
    }), [siteLang]);

    return <LanguageContext.Provider value={languageContext}>
        {children}
    </LanguageContext.Provider>;
};
